import type { RouteLocationNormalizedGeneric } from 'vue-router';
import { useRequestHeader, useRoute } from '#imports';

export type SiteCountry = 'NL' | 'BE';
export enum SiteCountries {
  NL = 'nl',
  BE = 'be',
}
/**
 * Returns the country of the site. This is determined by the hostname or the query parameter `country`.
 */
export default function (route?: RouteLocationNormalizedGeneric) {
  const routeToUse = route || useRoute();
  const { query } = routeToUse;
  const { queryAsString } = useQueryParams(route);

  const countryParam = queryAsString(query.country);
  const countryFromUrl = countryParam
    ? countryParam.toLowerCase() === 'be'
      ? SiteCountries.BE
      : SiteCountries.NL
    : undefined;

  const hostFromRequest = import.meta.server ? useRequestHeader('host') : undefined;
  const hostFromUrl = import.meta.client ? window.location.host : undefined;
  const host = hostFromRequest || hostFromUrl;
  const countryFromHost = host?.includes('.be') ? SiteCountries.BE : SiteCountries.NL;

  const country = countryFromUrl || countryFromHost;
  return country;
}
